import { Form, Input, Typography } from "antd";
import React from "react";
import inputStyles from "../../../../styles/Custom/Input.module.css";

const CourseOfStay = () => {
  return (
    <>
      <Typography className="forms-ip-sentence">
        <Typography.Text>
          Over the course of stay with the center, He was undergoing regular
          physiotherapy, other supportive and symptomatic therapy. He remained
          cardio vascularly stable. However He{" "}
        </Typography.Text>
        <Form.Item
          style={{ display: "inline-block" }}
          name={["course_of_stay", "deterioration_reason"]}
        >
          <Input className={inputStyles.mdInput} style={{ width: "250px" }} />
        </Form.Item>
        <Typography.Text> and thus is being sent for </Typography.Text>
        <Form.Item
          style={{ display: "inline-block" }}
          name={["course_of_stay", "invesstigation"]}
        >
          <Input className={inputStyles.mdInput} style={{ width: "250px" }} />
        </Form.Item>
        <Typography.Text>
          {" "}
          investigation to your hospital as advised by the physicians
        </Typography.Text>
      </Typography>
    </>
  );
};

export default CourseOfStay;
